export default __webpack_public_path__ + "static/foundation_w.aed5b75e060d29999c9b63c4b37485a5.png";